import { render, staticRenderFns } from "./AppBottomCart.vue?vue&type=template&id=bb82c8a8"
import script from "./AppBottomCart.vue?vue&type=script&lang=js"
export * from "./AppBottomCart.vue?vue&type=script&lang=js"
import style0 from "./AppBottomCart.vue?vue&type=style&index=0&id=bb82c8a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports